<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-container grid-list-xs fluid class="mb-0 pb-0" style="padding: 5px;">
          <v-layout row style="padding: 10px;">
            <v-flex md6>
              <v-text-field
                ref="form"
                class="mr-1"
                append-icon="search"
                label="Search by Control no. or Card no."
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <!-- <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
            ></v-select>-->

            <v-btn fab dark small color="amber darken-2" @click="playData()">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel File</span>
            </v-tooltip>

            <refresh-button @refresh="refreshData()"></refresh-button>
          </v-layout>

          <v-layout row style="padding: 10px;">
            <v-layout>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  lazy
                  :disabled="queryParams.search ? true : false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :disabled="queryParams.search ? true : false"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  :disabled="queryParams.search ? true : false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :disabled="queryParams.search ? true : false"
                    v-model="dateTo"
                    label="Date To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <!-- <v-flex md6>
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search"
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-flex>-->
            <v-spacer></v-spacer>
            <!-- <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
            ></v-select>-->
          </v-layout>

          <message-dialog
            :dialog="messageDialog"
            :title="messageTitle"
            :message="messageText"
            @save="action === 'align' ? saveAlignTicket() : ''"
            @close="closeMessageDialog"
            :loading="messageLoading"
          ></message-dialog>

          <!-- Filter -->
          <!-- <v-divider></v-divider> -->
          <v-layout row>
            <v-flex sm4 md4>
              <v-btn flat @click="openFilterExpansion">
                <v-icon class="mr-3">{{
                  openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                }}</v-icon>
                <span>Filter {{ title }}</span>
              </v-btn>
            </v-flex>
          </v-layout>

          <filter-panel :openFilter="openFilter">
            <v-flex md3>
              <v-select
                v-model="filterCompany"
                :items="filterCompanies"
                label="By Company"
                clearable
                solo
              ></v-select>
            </v-flex>
            <v-flex md3>
              <v-select
                v-model="filterSubCompany"
                :items="filterSubCompanies"
                label="By Sub-Company"
                clearable
                solo
              ></v-select>
            </v-flex>
            <v-flex md3>
              <v-select
                v-model="filterPaymentType"
                :items="filterPaymentTypes"
                label="By Payment Type"
                clearable
                solo
              ></v-select>
            </v-flex>
            <v-flex md3>
              <v-select
                v-model="filterAlignment"
                :items="filterAlignments"
                label="By Status"
                clearable
                solo
              ></v-select>
            </v-flex>
          </filter-panel>

          <!-- <v-container grid-list-lg fluid style="padding: 0px;" class="pt-3">
          </v-container>-->
        </v-container>
        <v-divider></v-divider>

        <bottom-scroll @on-bottom="loadMore" :offset="queryParams.offset">
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  <span>{{ header.text.toUpperCase() }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td
                :class="[
                  'text-xs-center no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{ props.index + 1 }}
              </td>

              <td :class="['text-xs-center no-wrap']">
                <v-tooltip top>
                  <v-btn
                    v-if="
                      $moduleAccess('align_ticket_exception_report') &&
                        props.item.align_status === 1
                    "
                    class="ma-0 pa-0"
                    icon
                    small
                    slot="activator"
                    style="height: 16px; width: 15px;"
                    @click="openAlignTicket(props.item)"
                  >
                    <v-icon color="teal">swap_horiz</v-icon>
                  </v-btn>
                  <span>Align</span>
                </v-tooltip>
              </td>

              <td
                :class="[
                  'text-xs-center no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.datetime
                    ? $dateFormat(props.item.datetime, "YYYY-MM-DD")
                    : "--"
                }}
              </td>
              <td
                :class="[
                  'text-xs-center no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.datetime
                    ? $dateFormat(props.item.datetime, "HH:mm")
                    : "--"
                }}
              </td>
              <td
                :class="[
                  'text-xs-left no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{ props.item.company_code }}
              </td>
              <td
                :class="[
                  'text-xs-left no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{ props.item.control_no }}
              </td>
              <td
                :class="[
                  'text-xs-left no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{ props.item.card_no ? props.item.card_no : "--" }}
              </td>
              <td
                :class="[
                  'text-xs-left no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{ props.item.ticket_no }}
              </td>
              <td
                :class="[
                  'text-xs-left no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{ props.item.ticket_type }}
              </td>
              <td
                :class="[
                  'text-xs-left no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{ props.item.payment_type ? props.item.payment_type : "--" }}
              </td>
              <td
                :class="[
                  'text-xs-left no-wrap',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.passenger_type ? props.item.passenger_type : "--"
                }}
              </td>
              <td
                :class="[
                  'text-xs-right',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.km_from_wireless === null
                    ? "--"
                    : props.item.km_from_wireless
                }}
              </td>
              <td
                :class="[
                  'text-xs-right',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.km_to_wireless === null
                    ? "--"
                    : props.item.km_to_wireless
                }}
              </td>
              <td
                :class="[
                  'text-xs-right',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.amount_wireless === null
                    ? "--"
                    : props.item.amount_wireless.toFixed(2)
                }}
              </td>
              <td
                :class="[
                  'text-xs-right',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.km_from_sync === null
                    ? "--"
                    : props.item.km_from_sync
                }}
              </td>
              <td
                :class="[
                  'text-xs-right',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.km_to_sync === null ? "--" : props.item.km_to_sync
                }}
              </td>
              <td
                :class="[
                  'text-xs-right',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.amount_sync === null
                    ? "--"
                    : props.item.amount_sync.toFixed(2)
                }}
              </td>
              <td
                :class="[
                  'text-xs-right',
                  props.item.align_status == 1 || props.item.align_status == 2
                    ? 'red--text'
                    : '',
                ]"
              >
                {{
                  props.item.discrepancy === null
                    ? "--"
                    : props.item.discrepancy
                }}
              </td>
            </template>
          </v-data-table>
        </bottom-scroll>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
const now = new Date();

export default {
  data() {
    return {
      //filter
      openFilter: false,
      filterCompanies: [],
      filterCompany: null,
      filterSubCompanies: [],
      filterSubCompany: null,
      filterPaymentTypes: [
        {
          text: "CASH",
          value: "CASH",
        },
        {
          text: "CARD",
          value: "CARD",
        },
      ],
      filterPaymentType: null,
      filterAlignments: [
        {
          text: "ALIGNED",
          value: "true",
        },
        {
          text: "UNALIGNED",
          value: "false",
        },
      ],
      filterAlignment: null,

      title: "Ticket Exception Report",
      timeOut: null,
      theTableStyle: false,
      tableItems: [
        {
          text: "Default Table",
          value: false,
        },
        {
          text: "Grid Style Table",
          value: true,
        },
      ],
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        { text: "", align: "center", value: "action", sortable: false },
        {
          text: "Date",
          align: "center",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          sortable: false,
        },
        {
          text: "Company Code",
          align: "center",
          sortable: false,
        },
        {
          text: "Control No",
          align: "left",
          sortable: false,
        },
        {
          text: "Card No.",
          align: "left",
          sortable: false,
        },
        {
          text: "Ticket No",
          align: "left",
          sortable: false,
        },
        {
          text: "Ticket Type",
          align: "left",
          sortable: false,
        },
        {
          text: "Payment Type",
          align: "left",
          sortable: false,
        },
        {
          text: "Passenger Type",
          align: "left",
          sortable: false,
        },
        // {
        //   text: "Place From",
        //   align: "left",
        //   sortable: false
        // },
        // {
        //   text: "Place To",
        //   align: "left",
        //   sortable: false
        // },
        {
          text: "Km From (W)",
          align: "right",
          sortable: false,
        },
        {
          text: "Km To (W)",
          align: "right",
          sortable: false,
        },
        {
          text: "Amount (W)",
          align: "right",
          sortable: false,
        },
        {
          text: "Km From (S)",
          align: "right",
          sortable: false,
        },
        {
          text: "Km To (S)",
          align: "right",
          sortable: false,
        },
        // {
        //   text: "Location (lat, long)",
        //   align: "right",
        //   sortable: false
        // },
        {
          text: "Amount (S)",
          align: "right",
          sortable: false,
        },
        {
          text: "Discrepancy",
          align: "right",
          sortable: false,
        },
      ],
      items: [],
      totalItems: 0,
      queryParams: {
        search: "",
        limit: 300,
        offset: 0,
        company_id: null,
        sub_company_id: null,
        payment_type: null,
        date_from: null,
        date_to: null,
      },
      menu: false,
      menu1: false,
      date_from: this.$dateFormat(now, "YYYY-MM-DD"),
      date_to: this.$dateFormat(now, "YYYY-MM-DD"),
      play_status: false,
      messageDialog: false,
      messageTitle: "",
      messageText: "",
      messageLoading: false,
      action: "",
      viewData: {},
    };
  },
  created: function() {
    this.resetTable();
  },
  computed: {
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
    dateFrom: {
      get() {
        this.queryParams.date_from = this.date_from;
        return this.date_from;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_from = value;
        this.date_from = value;
      },
    },
    dateTo: {
      get() {
        this.queryParams.date_to = this.date_to;
        return this.date_to;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_to = value;
        this.date_to = value;
      },
    },
  },
  watch: {
    filterCompany: async function() {
      this.resetTable();
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.company_id = this.filterCompany;
        this.queryParams.sub_company_id = null;
        this.setFilterSubCompanies();
        this.filterSubCompany = null;
      } else {
        this.queryParams.company_id = null;
        this.queryParams.sub_company_id = null;
        this.setFilterSubCompanies();
        this.filterSubCompany = null;
      }
    },
    filterSubCompany: async function() {
      this.resetTable();
      if (
        this.filterSubCompany !== null &&
        this.filterSubCompany !== undefined &&
        this.filterSubCompany !== ""
      ) {
        this.queryParams.sub_company_id = this.filterSubCompany;
      } else {
        this.queryParams.sub_company_id = null;
      }
    },
    filterPaymentType: async function() {
      this.resetTable();
      if (
        this.filterPaymentType !== null &&
        this.filterPaymentType !== undefined &&
        this.filterPaymentType !== ""
      ) {
        this.queryParams.payment_type = this.filterPaymentType;
      } else {
        this.queryParams.payment_type = null;
      }
    },
    filterAlignment: async function() {
      this.resetTable();
      if (
        this.filterAlignment !== null &&
        this.filterAlignment !== undefined &&
        this.filterAlignment !== ""
      ) {
        this.queryParams.aligned = this.filterAlignment;
      } else {
        this.queryParams.aligned = null;
      }
    },
  },
  methods: {
    search(data) {
      this.resetTable();
      this.queryParams.search = data;

      this.queryParams.date_from = data ? null : this.date_from;
      this.queryParams.date_to = data ? null : this.date_to;
    },
    async getData() {
      // Start Loading
      this.$store.dispatch("startLoading");

      try {
        // Query Data
        let response = (
          await Services.getTicketExceptionReport(this.queryParams)
        ).data;

        // Assign the reponse data to items to be display on table
        this.items = this.items.concat(response.data);

        // Assign Total number of data
        this.totalItems = response.count;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async playData() {
      this.items = [];

      this.resetTable();

      // this.$refs.form.reset();

      this.play_status = true;
      this.getData();
    },
    refreshData() {
      this.date_from = this.$dateFormat(now, "YYYY-MM-DD");
      this.date_to = this.$dateFormat(now, "YYYY-MM-DD");
      this.$refs.form.reset();
      this.items = [];
      this.filterCompany = null;
      this.filterSubCompany = null;
      this.filterPaymentType = null;
      this.filterAlignment = null;

      this.resetTable();
    },
    resetTable() {
      this.queryParams.limit = 100;
      this.queryParams.offset = 0;

      this.play_status = false;
    },
    async loadMore() {
      if (!this.play_status) return;

      this.queryParams.offset += this.queryParams.limit;

      if (this.queryParams.offset >= this.totalItems) return;

      await this.getData();
    },
    //filter
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
      await this.setFilterSubCompanies();
    },
    async setFilterCompanies() {
      this.filterCompanies = [];

      const items = (await Services.getCompanies({})).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.filterCompanies.push(data);
      }
    },
    async setFilterSubCompanies() {
      this.filterSubCompanies = [];

      const items = (
        await Services.getSubCompanies({
          company_id: this.filterCompany,
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.filterSubCompanies.push(data);
      }
    },
    async downloadExcel() {
      this.$store.dispatch("startLoading");

      let items = [];

      let params = this.queryParams;

      params.limit = null;
      params.offset = null;

      try {
        let response = (await Services.getTicketWireless(params)).data;

        // Assign the reponse data to items to be display on table
        items = response.data;

        this.$store.dispatch("endLoading");
      } catch (error) {
        this.$store.dispatch("endLoading");

        return this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      const wscols = [];
      const dataToDownload = [];
      const header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();
      header.shift();
      //   header.unshift("");
      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length; i++) {
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 35 });
        wscols.push({ wch: 35 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
      }

      // theItem.push(this.items[e].
      // this.$dateFormat
      for (let e = 0; e < items.length; e++) {
        const theItem = [];

        theItem.push(
          this.items[e].datetime
            ? this.$dateFormat(this.items[e].datetime, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          this.items[e].datetime
            ? this.$dateFormat(this.items[e].datetime, "HH:mm")
            : "--"
        );
        theItem.push(this.items[e].company_code.toUpperCase());
        theItem.push(this.items[e].control_no.toUpperCase());
        theItem.push(this.items[e].card_no ? this.items[e].card_no : "--");
        theItem.push(this.items[e].ticket_no.toUpperCase());
        theItem.push(this.items[e].ticket_type.toUpperCase());
        theItem.push(
          this.items[e].payment_type
            ? this.items[e].payment_type.toUpperCase()
            : "--"
        );
        theItem.push(
          this.items[e].passenger_type
            ? this.items[e].passenger_type.toUpperCase()
            : "--"
        );
        theItem.push(
          this.items[e].km_from_wireless === null
            ? "--"
            : this.items[e].km_from_wireless
        );
        theItem.push(
          this.items[e].km_to_wireless === null
            ? "--"
            : this.items[e].km_to_wireless
        );
        theItem.push(
          this.items[e].amount_wireless === null
            ? "--"
            : this.items[e].amount_wireless
        );
        theItem.push(
          this.items[e].km_from_sync === null
            ? "--"
            : this.items[e].km_from_sync
        );
        theItem.push(
          this.items[e].km_to_sync === null ? "--" : this.items[e].km_to_sync
        );
        theItem.push(
          this.items[e].amount_sync === null ? "--" : this.items[e].amount_sync
        );
        theItem.push(
          this.items[e].discrepancy === null ? "--" : this.items[e].discrepancy
        );

        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    openAlignTicket(data) {
      this.messageDialog = true;
      this.messageTitle = "Ticket Alignment";
      this.messageText = "Are you sure you want to align this ticket?";
      this.action = "align";

      this.viewData = data;
    },
    closeMessageDialog() {
      this.messageDialog = false;
    },
    async saveAlignTicket() {
      this.messageLoading = true;

      let id = null;

      if (this.viewData) id = this.viewData.id;

      try {
        const response = await Services.alignTicket(id);

        if (response.status === 201 || response.status === 204) {
          this.playData();

          this.closeMessageDialog();

          this.$infoBar({
            type: "success",
            text: "Ticket has been aligned.",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      this.messageLoading = false;
      this.closeMessageDialog();
    },
  },
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
